// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"ProgressBar_progressBar__2xvrg","singleBar":"ProgressBar_singleBar__1Zhz4"};